<script>
  import { user } from '../stores'
  import OpenBuyModalButton from '../components/OpenBuyModalButton.svelte'
  import Insert from '../elements/Insert.svelte'
  import Dropzone from '../components/Dropzone.svelte'
  import EmptyStateFooterList from './EmptyStateFooterList.svelte'
</script>

<div class="content">
  {#if $user === undefined}
    <Insert persistent insert_position="before_previews">
      <span slot="toptitle">
        PRO FEATURE: DROP AND PREVIEW
      </span>
      <span slot="title">
        Preview fonts without installing,<br>
        just drag and drop them here!
      </span>
      <span slot="text">
        Do you have a large collection of fonts but don't want to install them all?
        Now you can drag and drop them into Wordmark to instantly preview them.
        <small>
          This feature is available in Wordmark Pro along with many other time-saving features.
        </small>
      </span>
      <span slot="button">
        <OpenBuyModalButton feature='taged_fonts_page'>Subscribe to <b>Wordmark Pro</b></OpenBuyModalButton> <Dropzone inputOnly>or drop some fonts to try</Dropzone>
      </span>
    </Insert>
    <EmptyStateFooterList>
      <li><small><b>Dropped fonts are not saved and will be forgotten as soon as you refresh the window.</b></small></li>
      <li><small>You can preview multiple fonts at once by selecting or dropping multiple font files or folders.</small></li>
      <li><small><a href="/help/previewing-without-installing/" target="_blank">Read more about this feature</a> in our help pages.</small></li>
    </EmptyStateFooterList>
  {:else}
    <div class="body">
      <h2>
        Drag and drop fonts into Wordmark,<br>
        <span>instantly preview them without installing</span>
      </h2>
      <p>
        This feature is useful if you have a large collection of fonts but don't want to install them all.<br>
        Simply drag and drop or select font files or folders to preview the fonts within Wordmark.
      </p>
      <span class="action">Drag and drop files here <Dropzone inputOnly/></span>
    </div>
    <EmptyStateFooterList>
      <li><small><b>Dropped fonts are not uploaded or saved and will be forgotten when you reload the page.</b></small></li>
      <li><small>You can preview multiple fonts at once by selecting or dropping multiple font files or folders.</small></li>
      <li><small>If you tag dropped fonts, they will exist under that tag when they are loaded again.</small></li>
      <li><small><a href="/help/previewing-without-installing/" target="_blank">Learn more about this feature in our help pages.</a></small></li>
    </EmptyStateFooterList>
  {/if}
</div>

<style>
  .content {
    min-height: calc(100vh - 16rem);
  }
  .body {
    padding: 2rem 1rem 3rem;
  }
  .body h2 {
    font-size: 2.2rem;
    margin-bottom: 2.5rem;
  }
  .body h2 span {
    color: var(--c-text);
  }
  .body p {
    margin-top: 3rem;
  }
  span.action {
    display: block;
    margin-top: 3rem;
    font-family: var(--PensumSans-Bold);
    color: var(--c-accent);
  }
</style>